export const AcceleratorsHtmlPageTitle = "Accelerators";
